/** Label and tag colour for a trip's state on the board. Trips dispatched earlier today can have moved on, so any state needs a label. */
const TRIP_STATE_TAGS: Record<string, { label: string; color: string }> = {
  dispatched: { label: 'Dispatched', color: 'processing' },
  pre_trip_failed: { label: 'Pre-trip failed', color: 'error' },
  in_transit: { label: 'In transit', color: 'processing' },
  exception: { label: 'Exception', color: 'error' },
  delivered: { label: 'Delivered', color: 'success' },
};

export function boardTripStateTag(status: string): { label: string; color: string } {
  const known = TRIP_STATE_TAGS[status];
  if (known) return known;
  const words = status.replaceAll('_', ' ');
  return { label: words.charAt(0).toUpperCase() + words.slice(1), color: 'default' };
}
